import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NotificationService } from 'src/modules/features/notification/services';
import { takeUntil, tap, map } from 'rxjs/operators';
import {
  TransitionController,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { FormControl } from '@angular/forms';
import {
  Router,
  NavigationEnd,
  Event as NavigationEvent,
} from '@angular/router';
import { Notification, AppFilter } from '@app/shared';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { MediaObserver } from '@angular/flex-layout';
import { DashboardProvider } from './services';
import { BannerMessageModal } from './modals/banner-message-modal/banner-message-modal.component';
import {
  AnalyticsService,
  AuthenticationService,
} from 'src/modules/core/services';
import { EwalletService } from '../admin/services/ewallet';
@Component({
  selector: 'app-contractor',
  templateUrl: './contractor.component.html',
  styleUrls: ['./contractor.component.scss'],
})
export class ContractorComponent implements OnInit, OnDestroy {
  apps: Array<any> = [];
  baseUrl = environment.API_SERVER;
  currentHost = environment.currentHost;
  eServicesURL = environment.ESERVICES_URL;
  private unsubscribe$: Subject<void> = new Subject<void>();

  // transition controllers (router transition coming soon)
  public detailTransitionCtrl = new TransitionController();
  public createTransitionCtrl = new TransitionController();
  public listTransitionCtrl = new TransitionController();

  // this variables controls the visbilities of list and create option component (check template)
  public isCreate: boolean = false;
  public selected: boolean = true;

  public createLoading: boolean = false;
  public createSuccess: boolean = false;
  public createError: string = null;
  public optionPopulated: boolean;
  public notifications: Notification[];
  public notification: Notification;
  public contactUs: boolean;
  public detailUsed: boolean;
  contactDetails: any;
  loadingScroll: boolean;
  public maxSize = 5;

  public unRead: Notification[];
  public read: Notification[];

  public countUnread: number;
  public innerWidth: number;

  read_status_false: any = false;
  isRestrictedEntity: boolean = false;
  //loading icon on clicking register.
  register() {
    this.loadingScroll = true;
  }

  searchParams: AppFilter;
  optionParams: AppFilter;
  filterType: AppFilter;
  loading: boolean;
  totalUnread: number = 0;

  filter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'read',
        op: 'eq',
        data: 'false',
      },
    ],
  };
  //our search control
  public search = new FormControl();
  config = {
    total: 0,
    page: 1,
    records: 0,
  };
  year = new Date().getFullYear();

  total: number = 0;
  page: number = 1;
  records: number = 0;

  searchFilter: string = '';
  organizationId: string;
  background: string;
  read_status: boolean;
  verified: string;

  //initial option type
  notificationSearch: Notification = {
    read: false,
  };

  error: string | null;
  permissions: any[];
  user;
  photo;
  token: string = window.localStorage.getItem('jwt');
  isBackground: boolean;
  isBanner: boolean;
  bannerMsg: any;
  bannerDesc: any;
  FADetails;
  TwoFactorDate;
  usedRecoveryCode: boolean = false;
  applicationConfig;
  isMda: boolean = false;
  constructor(
    public media: MediaObserver,
    private location: Location,
    private modalService: SuiModalService,
    private _searchsvc: NotificationService,
    private dashboardSvc: DashboardProvider,
    private router: Router,
    private auth: AuthenticationService,
    private walletService: EwalletService,
    private analyticsService: AnalyticsService
  ) {
    this.analyticsService.handleRouteEvents();
    const recovery = window.localStorage.getItem('recoveryCodes');
    if (recovery === 'true') {
      this.usedRecoveryCode = true;
    }
    this.innerWidth = window.innerWidth;
    this.getConfig();
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((event: NavigationEvent) => {
        if (event instanceof NavigationEnd) {
          let url = this.location.path();
          if (
            url.split('/')[2] == 'dashboard' ||
            url.split('/')[2] == 'application'
          ) {
            this.isBackground = true;
          } else {
            this.isBackground = false;
          }
        }
      });
    this.user = JSON.parse(window.localStorage.getItem('user'));
    const organization = JSON.parse(
      window.localStorage.getItem('organization')
    );
    if (organization.organizationTypeId.organizationTypeId === 'mda') {
      this.isMda = true;
    }
    if (organization.restrictedApplicationId) {
      this.isRestrictedEntity = true;
    }
    if (this.user && this.user.image) {
      console.log(this.user.image);
      this.photo = `${
        this.eServicesURL
      }/api-server/public/image/?media=${this.user.image.replace(/\\/g, '/')}`;
    } else {
      this.photo = 'assets/avatar/1.jpg';
    }
    if (this.user.totpEnabled) {
      this.get2FADetails();
    }
    this.searchParams = new AppFilter({ sidx: 'dateCreated', rows: 5 });
    this.searchParams.filters = JSON.stringify(this.searchFilter);
    this.optionParams = new AppFilter({ sidx: 'dateCreated', rows: 5 });
    this.optionParams.filters = JSON.stringify(this.filter);

    this.loadingScroll = false;
    if (this.user) {
      // this.organizationId = JSON.parse(window.localStorage.getItem('userData'))['appUser'].appUserId;
      this.organizationId = this.user.appUserId;
      // let token = window.localStorage.getItem('token');
      this.user['applications'].forEach((app) => {
        app['applicationHost'] =
          app['applicationHost'] + '?token=' + this.token;
        this.apps.push(app);
      });
      console.log('apps', this.apps);
      this.getRecord();
    }

    this._searchsvc.getRefreshNotification().subscribe((res) => {
      this.getPage(1);
      this.getUnreadPage(1);
    });

    this.getPage(1);
    this.getUnreadPage(1);
    if (window.localStorage.getItem('user')) {
      let authTokenPermission = JSON.parse(localStorage.getItem('permissions'));
      // this.permissions = JSON.parse(window.localStorage.getItem("permission"));
      this.permissions = authTokenPermission;
    }
    this.getBannerMsg();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    // Update the width when the window is resized
    this.innerWidth = (event.target as Window).innerWidth;
  }

  truncateSentence = (sentence: string) => {
    let max_length = 25;
    if (sentence.length > max_length) {
      return sentence.slice(0, max_length) + '...';
    } else {
      return sentence;
    }
  };
  getConfig() {
    this.walletService
      .get2FAConfig({ configId: 'E_WALLET_PAGE_ACTIVE' })
      .subscribe(
        (res: any) => {
          this.applicationConfig = res.value === 'true' ? true : false;
        },
        (error) => {}
      );
  }
  // get page request options with filter params
  getPage(page) {
    this.searchParams.page = page;
    this.loading = true;
    this._searchsvc
      .getNotifications({
        appUserId: this.organizationId,
        params: this.searchParams,
      })
      .pipe(
        tap((res) => {
          this.total = +res['records'];
          this.page = page;
          this.records = +this.searchParams.rows;
        }),
        map((res) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: Notification[]) => {
          this.loading = false;
          this.notifications = res;
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
  }

  getUnreadPage(page) {
    this.loading = true;
    this._searchsvc
      .getNotifications({
        appUserId: this.organizationId,
        params: this.optionParams,
      })
      .pipe(
        tap((res) => {
          this.totalUnread = +res['records'];
          this.page = page;
          this.records = +this.optionParams.rows;
        }),
        map((res) => res['rows']),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(
        (res: Notification[]) => {
          this.loading = false;
          this.unRead = res;
          this.checkOptionList(this.unRead);
        },
        (error) => {
          this.loading = false;
          this.error = error;
        }
      );
  }

  checkOptionList(value: Notification[]) {
    if (value != null && value.length > 0) {
      this.optionPopulated = true;
    } else {
      this.optionPopulated = false;
    }
  }

  getRecord() {
    this.loading = true;
    this.dashboardSvc.getCompanyDetail({}).subscribe((res) => {
      this.verified = res['companyRegVerified'] ? 'VERIFIED' : 'UNVERIFIED';
      this.loading = false;
    });
  }

  getBannerMsg() {
    this._searchsvc
      .getUsersAppConfigs({
        appUserId: this.organizationId,
        appConfigId: 'BANNER_MESSAGE',
      })
      .subscribe(
        (res) => {
          this.isBanner = res['isAvailableToOrg'];
          this.bannerMsg = res['appConfigValue'];
          this.bannerDesc = res['appConfigDescription'];
        },
        (error) => {
          this.error = error.message ? error.message : error;
        }
      );
  }

  showBanner() {
    this.modalService
      .open(new BannerMessageModal('Information', this.bannerMsg))
      .onApprove((eq) => {
        console.log('denied');
      })
      .onDeny((eq) => console.log('denied'));
  }

  ngOnDestroy() {
    // unsubscribe all subsciptons
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    document.getElementsByTagName('body')[0].style.overflow = 'hide';
  }
  logout() {
    localStorage.clear();
    this.auth.logout();
    this.router.navigate(['/home-page']);
  }
  ngOnInit(): void {
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  }
  get2FADetails() {
    this.error = null;
    this.walletService
      .get2FADetails({
        appUserId: this.user.appUserId,
      })
      .subscribe(
        (res: any) => {
          this.FADetails = res;
          // res.ewalletActivated
          //   ? this.router.navigate(['/contractor/wallet/activate'])
          //   : '';
        },
        (error) => {
          this.error = error.error;
        }
      );
  }
}
